import { EstadoPeriodontograma, CaraPerio } from "app/models/periodontograma.interface";
import { EstadoOdontograma } from "app/models/odontograma.interface";

const TOOTH_AUSENTE = ["ausente", "extraccion_indicada", "no_erupcionado"];
const CARAS: CaraPerio[] = ["vestibular", "palatino"];

export interface IndicesPerio {
  bop: number | null;
  placa: number | null;
  supuracion: number | null;
  pdMedia: number | null;
  sitios5mas: number;
  dientesPresentes: number;
  dientesTotales: number;
  sitiosExaminados: number;
}

export function dientePresente(
  fdi: string,
  estado: EstadoPeriodontograma,
  odontogramaEstado: EstadoOdontograma
): boolean {
  const odo = odontogramaEstado?.[fdi];
  if (odo?.tooth && TOOTH_AUSENTE.includes(odo.tooth)) return false;
  const e = estado[fdi];
  return e ? e.presente !== false : true;
}

export function calcularIndices(
  estado: EstadoPeriodontograma,
  odontogramaEstado: EstadoOdontograma,
  fdiUniverse: string[]
): IndicesPerio {
  let examinados = 0;
  let sumaSondaje = 0;
  let sangrados = 0;
  let placas = 0;
  let supuraciones = 0;
  let sitios5mas = 0;
  let dientesPresentes = 0;

  for (const fdi of fdiUniverse) {
    if (!dientePresente(fdi, estado, odontogramaEstado)) continue;
    dientesPresentes++;
    const entrada = estado[fdi];
    if (!entrada) continue;
    for (const cara of CARAS) {
      const datos = entrada[cara];
      if (!datos) continue;
      for (let i = 0; i < 3; i++) {
        const sondaje = datos.sondaje?.[i] ?? null;
        if (sondaje === null) continue;
        examinados++;
        sumaSondaje += sondaje;
        if (sondaje >= 5) sitios5mas++;
        if (datos.sangrado?.[i]) sangrados++;
        if (datos.placa?.[i]) placas++;
        if (datos.supuracion?.[i]) supuraciones++;
      }
    }
  }

  const pct = (n: number): number | null =>
    examinados === 0 ? null : Math.round((n / examinados) * 100);

  return {
    bop: pct(sangrados),
    placa: pct(placas),
    supuracion: pct(supuraciones),
    pdMedia: examinados === 0 ? null : Math.round((sumaSondaje / examinados) * 10) / 10,
    sitios5mas,
    dientesPresentes,
    dientesTotales: fdiUniverse.length,
    sitiosExaminados: examinados,
  };
}
